export default {
    ABERTO: 1,
    FECHADO : 2,
}